import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Link } from "react-router-dom";

import Layout from "./components/Layout";
import Home from "./pages/Home";
import Accomplishments from "./pages/Accomplishments";
import Gallery from "./pages/Gallery";
import Media from "./pages/Media";
import Shop from "./pages/Shop";
import Speaking from "./pages/Speaking";
import Sponsors from "./pages/Sponsors";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const NotFound = () => (
  <div className="max-w-3xl mx-auto py-24 px-6 text-center">
    <div className="font-pixel text-2xl text-black/70">ERROR 404</div>
    <h1 className="font-display tracking-wider text-7xl text-[#FF007F] mt-3">PAGE LOST AT SEA</h1>
    <p className="font-body text-lg mt-4">This page hasn't been built yet (or it caught a wave the wrong way).</p>
    <Link to="/" data-testid="notfound-home"
      className="inline-block mt-8 font-display text-2xl tracking-wider px-6 py-3 bg-[#FFD400] border-4 border-black shadow-[6px_6px_0_#000] btn-press">
      ← Back home
    </Link>
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/accomplishments" element={<Accomplishments />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/media" element={<Media />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/speaking" element={<Speaking />} />
            <Route path="/sponsors" element={<Sponsors />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
